/**
 * Redux Store Configuration
 * Consolidated store using Redux Toolkit
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth.slice';
import permissionReducer from './slices/permission.slice';
import snackbarReducer from './slices/snackbar.slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    permission: permissionReducer,
    snackbar: snackbarReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Type definitions for TypeScript (if migrating in future)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

export default store;

